<!--
  name : 김혜진
  desc : 가입한 사용자 레이아웃폼
  date : 2020-10-05
-->
<template>
  <v-app id="bgSt">
    <s-header></s-header>
    <v-card id="navNcon"
      class="overflow-hidden"
    >
      <s-navigation></s-navigation>
      <!--
      <s-navigation v-if="responsive"></s-navigation>
    -->
      <s-content class="pd-0"></s-content>
    </v-card>
    <s-footer></s-footer>
  </v-app>
</template>
<script>
import SHeader from '@/views/layout/components/header'
import SNavigation from '@/views/layout/components/navigation'
import SContent from '@/views/layout/components/content'
import SFooter from '@/views/layout/components/footer'

export default {
  name: 'memberLayout',
  components: {
    SHeader,
    SNavigation,
    SContent,
    SFooter
  },
  filters: {
  },
  data () {
    return {}
  },
  computed: {
    responsive: {
      get () {
        return this.$store.state.actions.responsive
      }
    }
  },
  created () {
  },
  mounted () {
    this.onResponsiveInverted()
    window.addEventListener('resize', this.onResponsiveInverted)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResponsiveInverted)
  },
  methods: {
    onResponsiveInverted () {
      if (window.innerWidth < 960) {
        // 브라우저 크기가 960보다 작아졌을때 responsive 변수가 true로..
        this.$store.dispatch('setResponsive', true)
      } else {
        // 브라우저 크기가 960보다 커졌을때 responsive 변수가 false로..
        this.$store.dispatch('setResponsive', false)
      }
    }
  }
}
</script>
<style scoped>
</style>